import Facade from '@/Facade'
import GameSignals from '@/signals/GameSignals'
import { GameStatesEnum } from '@/states/GameStatesEnum'
import { isMaxWinCapReached } from '@/states/round/MaxWinCap'
import { RoundRestoreUtil } from '@/utils/RoundRestoreUtil'
import { BaseState } from '@stateMachine/BaseState'

export class StopRoundState extends BaseState {
    /** Beat between the credited balance and the next chained round. */
    private static readonly NEXT_ROUND_DELAY_MS = 500

    public begin() {
        RoundRestoreUtil.stopRound()

        // if (this._model.roundState.isRestoredRound) {
        //     this._model.resetCurrentBet()
        // }

        const spinBalance = Number(this._model.spinData?.balance)
        // Treat 0 as a real server balance — `> 0` / `|| 0` incorrectly restored the pre-spin wallet
        // after Buy Bonus spent the entire balance.
        const finalBalance =
            Number.isFinite(spinBalance) && spinBalance >= 0
                ? this._model.balance
                : this._model.balance -
                  (this._model.roundState.isFreeSpins ? 0 : (this._model.bonusBuyBet ?? this._model.currentBet) / 100) +
                  (this._model.winCurrency || 0)
        GameSignals.balanceHasChanged.emit(finalBalance)
        this._model.winCounter.stopRound()
        GameSignals.roundStop.emit()

        if (!this._model.freeRoundsActive() && this._model.spinData.freeround) {
            GameSignals.changeDialogState.connect(this.onChangeDialogState)
        } else {
            this.end()
        }
    }

    private onChangeDialogState = (isDialogShown: boolean) => {
        if (!isDialogShown) {
            GameSignals.unLockGamePanel.emit()
            this._stateMachine.setState(GameStatesEnum.IDLE_STATE)
        }
    }

    public end = () => {
        // A capped round must land the player in idle: no autoplay, no promo spin chaining.
        if (isMaxWinCapReached(this._model)) {
            GameSignals.unLockGamePanel.emit()
            this._stateMachine.setState(GameStatesEnum.IDLE_STATE)
            return
        }

        if (Facade.isAuto || this._model.spinState.isIdleStateWinSkipped || this._model.hasPromoSpinsRemaining()) {
            // begin() has just credited the win to the balance. Chaining the next round in the
            // same beat repaints the balance with the new stake already taken off and clears the
            // Win field at the same time, so the stake reads as if it came out of the win.
            setTimeout(this.onStartNextRound, StopRoundState.NEXT_ROUND_DELAY_MS)
        } else {
            GameSignals.unLockGamePanel.emit()
            this._stateMachine.setState(GameStatesEnum.IDLE_STATE)
        }
    }

    public cleanUp() {
        GameSignals.changeDialogState.disconnect(this.onChangeDialogState)
    }

    private onStartNextRound = () => {
        if (Facade.requestOngoing) {
            window.setTimeout(this.onStartNextRound, 100)
        } else {
            this._stateMachine.setState(GameStatesEnum.START_ROUND_STATE)
        }
    }
}
